<div class="announcement-thread" *ngIf="announcements.length">
  <div class="app-divider-line"></div>
  <div *ngFor="let announcement of announcements">
    <div class="announcement-thread-message-author">
      {{ announcement.authorName }}
    </div>
    <app-wysiwyg-editor [value]="announcement.body" mode="view" minHeight="0" />
  </div>
</div>
